var map = {
	"./ECPC.png": 50169,
	"./Financial Literacy 2.png": 3805,
	"./TALENT BOOST LOGO.png": 72079,
	"./courseDefaultImage.webp": 21682,
	"./einstein_jr_logo_1__720.png": 53237
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20565;